var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0462 7.66021L3.7207 6.54395V14.792C3.7207 15.1687 4.02606 15.474 4.40274 15.474H15.3175C15.6942 15.474 15.9996 15.1687 15.9996 14.792V11.7532L10.0462 7.66021Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0462 0.590576H4.40274C4.02606 0.590576 3.7207 0.895932 3.7207 1.27261V4.31144L10.0462 8.03231L13.395 9.14857L15.9996 8.03231V4.31144L10.0462 0.590576Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7207 4.31128H10.0462V8.03215H3.7207V4.31128Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.24788 3.56738H3.7207V12.8696H8.24788C8.62405 12.8683 8.92869 12.5637 8.92992 12.1875V4.24942C8.92869 3.87325 8.62405 3.56861 8.24788 3.56738Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.8758 3.93921H3.7207V13.2414H7.8758C8.25196 13.2402 8.55661 12.9355 8.55783 12.5593V4.62124C8.55661 4.24507 8.25196 3.94043 7.8758 3.93921Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.8758 3.93921H3.7207V12.4972H7.8758C8.25196 12.496 8.55661 12.1913 8.55783 11.8152V4.62124C8.55661 4.24507 8.25196 3.94043 7.8758 3.93921Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.50371 3.93921H3.7207V12.4972H7.50371C7.87988 12.496 8.18452 12.1913 8.18574 11.8152V4.62124C8.18452 4.24507 7.87988 3.94043 7.50371 3.93921Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.682033 3.93921H7.50387C7.88054 3.93921 8.1859 4.24456 8.1859 4.62124V11.4431C8.1859 11.8198 7.88054 12.1251 7.50387 12.1251H0.682033C0.305356 12.1251 0 11.8198 0 11.4431V4.62124C0 4.24456 0.305356 3.93921 0.682033 3.93921Z",
    fill: "url(#paint0_linear_41979_9117)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11279 10.2491L3.54756 8.02588L2.23298 5.81494H3.29045L4.00783 7.22887C4.07406 7.36319 4.11945 7.46291 4.14402 7.52877H4.15332C4.19969 7.4232 4.24933 7.31909 4.30215 7.21659L5.06902 5.81569H6.03979L4.69172 8.01361L6.07403 10.2491H5.04112L4.21248 8.69713C4.17345 8.6311 4.14033 8.56174 4.11351 8.48988H4.10123C4.07696 8.56028 4.04475 8.62769 4.00523 8.69081L3.15204 10.2491H2.11279Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3177 0.590576H10.0464V4.31144H15.9998V1.27261C15.9998 0.895932 15.6944 0.590576 15.3177 0.590576Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0464 8.03223H15.9998V11.7531H10.0464V8.03223Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41979_9117",
    x1: 1.42206,
    y1: 3.40628,
    x2: 6.76385,
    y2: 12.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeExcel);
export default __webpack_public_path__ + "static/media/typeExcel.747b87b0.svg";
export { ForwardRef as ReactComponent };